const componentsComboboxPersonMultiSelectComboboxEn = {
  clearAllPersonOptions: 'Clear all selections',
};

export default componentsComboboxPersonMultiSelectComboboxEn;
